<template>
    <div class="handleIcon">
        <i :class="!isMode ? 'el-icon-edit' : 'el-icon-back'" @click="modeChange"></i>
    </div>
</template>

<script>
export default {
    props: ['isMode'],
    methods: {
        modeChange() {
            this.$emit('modeChange', false)
        }
    }
}
</script>

<style lang="scss" scoped>
.handleIcon {
    width: 30px;
    height: 100%;
    text-align: center;
    cursor: pointer;

    i {

        &:hover {
            color: red
        }
    }
}
</style>